/**
 * val(target[, value]): the semantics of jQuery's .val(), for migrated views.
 *
 *  get: first matched element; formatted .number inputs return the raw number text
 *       (as jquery-number's hook did); multi-selects return an array.
 *  set: every matched element; .number inputs are re-formatted; Tom Select widgets are synced.
 *       Like jQuery, setting does not fire `change` (use App.dom.trigger for that).
 */
import { qsa } from './dom';
import { setNumber } from './number';
import { syncFromDom } from '../components/Select';

function getOne(el) {
    if (!el) return undefined;
    if (el.tagName === 'SELECT' && el.multiple) return Array.from(el.selectedOptions).map((o) => o.value);
    if (el.tagName === 'SELECT') {
        // select2-era pages test `.val() == null` for "nothing chosen". Tom Select inserts an
        // empty <option value=""> in that state, so report null when no item is selected.
        if (el.selectedIndex < 0) return null;
        if (el.tomselect && el.tomselect.items.length === 0) return null;
    }
    if (el.dataset && el.dataset.numberInit) return String(el.value).replace(/,/g, '');
    return el.value;
}

function setOne(el, value) {
    if (el.tagName === 'SELECT') {
        const values = (Array.isArray(value) ? value : [value]).map((v) => (v == null ? '' : String(v)));
        Array.from(el.options).forEach((o) => {
            o.selected = values.includes(o.value);
        });
        if (!el.multiple && !values.some((v) => Array.from(el.options).some((o) => o.value === v))) el.selectedIndex = -1;
        if (el.tomselect) syncFromDom(el);
        return;
    }
    if (el.dataset && el.dataset.numberInit) {
        setNumber(el, value);
        return;
    }
    el.value = value == null ? '' : value;
}

export function val(target, ...args) {
    const els = qsa(target);
    if (args.length === 0) return getOne(els[0]);
    els.forEach((el) => setOne(el, args[0]));
    return els;
}
